import { TitlesFootnotesReadDto } from "functions/api/tlfItem/TitlesFootnotesReadDto";
import { isArsMasterReadDto, TlfItemReadDto } from "functions/api/tlfItem/TlfItemReadDto";
import { toArsTlfSnapshot } from "./toArsTlfSnapshot";

/**
 * Normalises presentation-only ARS promotion for comparison against the persisted baseline.
 *
 * @param data - Current or persisted TLF data used to derive the unsaved-change flag.
 * @returns The original TLF, or its shell representation when no variants have been designed.
 */
export const toTlfChangedData = (
  data: TlfItemReadDto | TitlesFootnotesReadDto | null,
): TlfItemReadDto | TitlesFootnotesReadDto | null => {
  if (
    isArsMasterReadDto(data) &&
    Object.keys(data.allVariantPatches).length === 0 &&
    data.variantTemplates.length === 0
  ) {
    return toArsTlfSnapshot(data);
  }
  return data;
};
